import React, { useCallback, useRef, useImperativeHandle, forwardRef } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import _ from 'lodash';
import { useSelector } from 'react-redux';
import DropdownSelector from '../../../../markup/selectors/DropdownSelector';
import { selectPersonas } from '../../../../../store/personasSlice';
import PersonasDataProvider from '../../../../personas/PersonasDataProvider';
import UserManager from '../../../../../core/UserManager';
import PubSub from 'pubsub-js';
import GlobalConst from '../../../../../utils/GlobalConst';
import { selectAuthUser } from '../../../../../store/authSlice';
import { notifyActivePersonaChanged } from '../../../../personas/PersonasMethods';

const ActivateMenuBottom = forwardRef(({ menuExpanded, onExpand }, ref) => {
	const authUser = useSelector(selectAuthUser) || {};
	const personas = useSelector(selectPersonas) || [];
	const dropdownRef = useRef(null);
	const [updatingPersona, setUpdatingPersona] = React.useState(false);

	useImperativeHandle(ref, () => ({
		closePopover: () => {
			if (dropdownRef.current) {
				dropdownRef.current.setState({ popoverOpened: false });
			}
		}
	}));

	const changePersona = useCallback(async (opt) => {
		if (_.isUndefined(opt)) return null;
		setUpdatingPersona(true);

		try {
			if (opt === null && _.isNumber(UserManager.user?.persona?.id)) {
				await PersonasDataProvider.updatePersona(UserManager.user.persona.id, { set_default: false });
				UserManager.user.persona = null;
				notifyActivePersonaChanged();
			} else if (_.isNumber(opt)) {
				const data = await PersonasDataProvider.updatePersona(opt, { set_default: true });
				if (UserManager.isPersonaRecord(data)) {
					UserManager.setActivePersonaFromApi(data);
				} else {
					UserManager.user.persona = _.find(UserManager.personasData, ['id', opt]);
				}
				notifyActivePersonaChanged();
			}
		} catch (xhrError) {
			PubSub.publish(GlobalConst.SHOW_MODAL_MSG, { type: GlobalConst.MODAL_TYPE_ERROR, message: xhrError, title: 'Error updating persona' });
		} finally {
			setUpdatingPersona(false);
		}
	}, []);

	const { canAccessPersonas } = authUser;
	const allPersonas = _.map(personas, (persona) => ({
		id: persona.id,
		title: persona.title,
		icon: <img src={persona?.attributes?.icon} className="dp-logo" />
	}));
	const selectedPersona = authUser?.persona?.id;

	if (!canAccessPersonas || allPersonas?.length <= 1) return null;

	return (
		<div className="menu-bottom" onClick={() => { if (!menuExpanded) onExpand(); }}>
			<DropdownSelector
				ref={dropdownRef}
				id="personas"
				className={cx('header-dropdown', { disabled: updatingPersona })}
				options={allPersonas}
				selections={selectedPersona || [null]}
				disabled={updatingPersona}
				onChange={(opt) => changePersona(opt)}
				idKey="id"
				titleKey="title"
				noSelectedClass={true}
				titleBySelection={true}
				multiselect={false}
				showChevron={true}
				selectionType="id"
				renderIcon={true}
				disableCheckbox={true}
			/>
		</div>
	);
});

ActivateMenuBottom.displayName = 'ActivateMenuBottom';

ActivateMenuBottom.propTypes = {
	menuExpanded: PropTypes.bool.isRequired,
	onExpand: PropTypes.func.isRequired
};

export default ActivateMenuBottom;
